export default "__VITE_ASSET__BXpw$VBl__"